import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import { SVGPureIcon } from '@/ui';
import { getMcpToolsConfig, McpToolsConfig } from '@shared/constants/mcp';
import connectionLineStore from '@/components/chat-history/connection-line/store';
import CircleLoading from '@/components/ani/circle-loading';
import { useEffect } from 'react';
import ProcessBar from '@/components/process-bar';
import EE from '@/common/event';
import FlowIcon from '@/components/flow-icon';

const McpToolsOrder = observer((props) => {
  const {
    className = '',
    children,
    event,
    mcpStore,
    messageItem,
    scene = 'message',    // message 消息中，可点击 panel 不可点击，不显示图标
    isAITyping,
  } = props;

  const hasDone = event.status == "success";
  const config = getMcpToolsConfig(event);
  const isSearch = event?.type == "queryList"

  // useEffect(() => {
  //   HelperCore.log(`McpToolsOrder render`, HelperCore.copyObj(event), config);
  // }, []);

  if(config.hidden){
    return null;
  }

  const toolConfig = mcpStore ? mcpStore.getFixedToolText(event) : null;
  let disabled = false;
  try{
    disabled = toolConfig.disabled;
  } catch(e){}

  const id = `${messageItem?.msg_id || ''}_${event?.planStepId || ''}`;

  return (
    <div className="tools-order flex flex-col relative overflow-hidden rounded-6px">
      <div 
        className={`js-mcptools mcptools px-10px py-8px flex w-full border-black border-opacity-10 border-1px hover:bg-black hover:bg-opacity-3 rounded-6px max-w-full ${className} ${mcpStore && scene == 'message' && !disabled ? 'cursor-pointer' : ''}`}
        data-id={id}
        // data-json={JSON.stringify(event)}
        data-tool={event?.tool}
        data-idx={event?.idx}
        onClick={
          (e) => {
            e.stopPropagation();
            if(!mcpStore || scene != 'message'){
              return;
            }
            if(disabled){
              return;
            }
            if(!config || config.key == "default"){
              return;
            }
            if(messageItem){
              mcpStore.setPanelMessageId(messageItem.msg_id);
            }
            if(mcpStore.currentPanelId == event.planStepId && mcpStore.showRightPanel){
              EE.emit("vnc-cards-scroll");
            }
            else {
              mcpStore.setCurrentPanelId(event.planStepId, true);
              EE.emit("vnc-cards-scroll");
            }
            connectionLineStore.updatePoint(id);
          }
        }
        >
        {
          mcpStore.isAgentFlow && !["planStatus", "planThink"].includes(event.type)
          ? <FlowIcon event={event} className='size-18px mr-3px rounded-4px flex-shrink-0' />
          : <SVGPureIcon name={`${config.getIcon ? config.getIcon(event) : config.icon}`} className='size-18px mr-3px flex-shrink-0' />
        }
        {
          // 假冒 MCP 调用
          event.serverName == "nami_gen_html_server" && event.tool == "gen_html"
          ? (
            <div className="mcptools-text text-13px text-black text-opacity-80 leading-18px flex items-center max-w-8/10">
              生成网页
            </div>
          )
          : event.type == "toolStatus"
          ? (
            <div className="mcptools-text text-13px text-black text-opacity-80 leading-18px flex items-center max-w-8/10">
              <div className="flex-shrink-0 mcp-mobile-hidden">
                {mcpStore.isAgentFlow && event.agent_name ? `${event.agent_name}：` : '调用技能（MCP工具）：'}
              </div>
              {
                event.serverName
                ? (
                  <>
                    <div className="font-bold flex-shrink truncate ml-6px text-black text-opacity-80">{event.serverNameCN || event.serverName}</div>
                    <div className="h-1px w-6px bg-black bg-opacity-80 mx-6px"></div>
                  </>
                )
                : null
              }
              <div className="font-bold text-black text-opacity-80 flex-shrink truncate">{event.toolCN || event.tool}</div>
            </div>
          )
          : isSearch
          ? (
            <div className='mcptools-text text-13px leading-18px text-black'>
              <span className='font-bold'>搜索：</span>
              <span>共获得{event?.detail?.results?.[0]?.length || 0}个结果</span>
            </div>
          )
          : (
            <div className="mcptools-text text-13px text-black text-opacity-80 leading-18px flex items-center max-w-8/10">
              {children}
            </div>
          )
        }
        {/* loading/done */}
        {
          !isSearch
          ? (
            <>
              {
                toolConfig?.eventStatus == "failed"
                ? <SVGPureIcon name={`mcp_error`} className='size-16px ml-6px text-[#FF3B30] flex-shrink-0' />
                : !hasDone
                ? (
                  mcpStore && isAITyping && event.type != "planUpdate"
                  ? null
                  // ? <CircleLoading className="!size-16px ml-6px flex-shrink-0" />
                  : null
                )
                : <SVGPureIcon name={`done`} className='size-16px ml-6px text-[#33C481] flex-shrink-0' />
              }
            </>
          )
          : null
        }
      </div>
      {/* loading */}
      {
        toolConfig.eventStatus == "failed" || !toolConfig.eventStatus
        ? null
        : !hasDone
        ? (
          mcpStore && isAITyping && event.type != "planUpdate"
          ? <ProcessBar className="absolute bottom-1px" />
          : null
        )
        : null
      }
    </div>
  )
});
export default McpToolsOrder;